import qs from 'qs'
import api from '..'

export type Query = Record<string, any>

const lmsProfilesList = (q?: Query) => {
  return api.get(`enrols?${qs.stringify({ q })}`).then(({ data: { data } }) => {
    return data ? data.map(({ attributes }: any) => attributes) : []
  })
}

export default lmsProfilesList
